
import { useStore } from '@/store/store';
import { computed, defineComponent, ref, watch } from 'vue';
import Range from '@/components/form/Range.vue';
import { referenceToString } from '@/utilities/utilityFunctions';
import PlaceholderText from '@/components/form/PlaceholderText.vue';
import Button from '@/components/form/Button.vue';

const FINE_RANGE = 5;

export default defineComponent({
  name: 'QaSelectVerseRange',
  components: { Range, PlaceholderText, Button },
  emits: {
    select: null,
  },
  setup() {
    const store = useStore();

    const selectedRoughIndex = ref(0);
    const selectedFineIndex = ref(0);

    const verseList = computed(() => {
      return store.getters['session/verseList'];
    });

    const verses = computed(() => {
      return (verseList.value && verseList.value.verses) || [];
    });

    const showFine = computed(() => {
      return !verses.value || verses.value.length > FINE_RANGE * 2;
    });

    const roughTooltip = computed(() => {
      return (
        (verses.value.length > selectedRoughIndex.value &&
          referenceToString(verses.value[selectedRoughIndex.value])) ||
        selectedRoughIndex.value
      );
    });

    const fineVerses = computed(() => {
      const max = verses.value.length;

      let start = Math.max(selectedRoughIndex.value - FINE_RANGE, 0);
      let end = Math.min(selectedRoughIndex.value + FINE_RANGE + 1, max);

      if (start === 0 && end < max) {
        end = Math.min(FINE_RANGE * 2 + 1, max);
      } else if (end === max && start > 0) {
        start = Math.max(end - (FINE_RANGE * 2 + 1), 0);
      }

      return verses.value.slice(start, end);
    });

    const selectedVerse = computed(() => {
      return (
        fineVerses.value.length > selectedFineIndex.value &&
        fineVerses.value[selectedFineIndex.value]
      );
    });

    const finalSelectedIndex = computed(() => {
      if (selectedVerse.value) {
        return verses.value.indexOf(selectedVerse.value);
      }
      return -1;
    });

    const fineTooltip = computed(() => {
      return (
        (selectedVerse.value && referenceToString(selectedVerse.value)) ||
        selectedFineIndex.value
      );
    });

    watch(selectedRoughIndex, () => {
      if (selectedRoughIndex.value + FINE_RANGE > verses.value.length) {
        selectedFineIndex.value =
          FINE_RANGE * 2 - (verses.value.length - 1 - selectedRoughIndex.value);
      } else if (selectedRoughIndex.value < FINE_RANGE) {
        selectedFineIndex.value = selectedRoughIndex.value;
      } else {
        selectedFineIndex.value = FINE_RANGE;
      }
    });

    // Add something on mounted to check user's previous session final verse and set to selectedRoughIndex

    return {
      verses,
      fineVerses,
      roughTooltip,
      fineTooltip,
      selectedRoughIndex,
      selectedFineIndex,
      finalSelectedIndex,
      showFine,
    };
  },
});
